import { render, staticRenderFns } from "./Slideshow.vue?vue&type=template&id=1c0d6bdc&"
import script from "./Slideshow.vue?vue&type=script&lang=coffee&"
export * from "./Slideshow.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports